<template>
  <v-dialog
      v-model="show"
      :max-width="'900px'"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Leistung wählen</span>
      </v-card-title>
      <v-card-text>
        <v-row>
              <v-col>
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Leistungsgruppen</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_legr"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>

                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedLegr"
                      color="indigo"
                  >
                    <template v-for="(group, i) in myList">
                      <v-divider v-if="group.title" style="border-color: rgba(0,0,0,0.46)"></v-divider>
                      <v-subheader v-if="group.title" style="margin-left: -16px">{{ group.title }}</v-subheader>
                      <v-list-item
                          v-for="(item, i) in group.items"
                          :key="item.gischl"
                          :value="item.name"
                          :style="{
                        'border-bottom': i === group.items.length - 1 ? 'none': 'rgba(128,128,128,0.25) thin solid',
                      }"
                      >
                        <v-row>
                          <!--v-col cols="3">
                            <v-list-item-title v-text="item.gischl"></v-list-item-title>
                          </v-col-->
                          <v-col>
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col>
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Leistungsarten</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_lear"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedLear"
                      color="indigo"
                  >
                      <v-list-item
                          v-for="(item, i) in filteredLears"
                          :key="item.id"
                          :value="item.id"
                          style="border-bottom: rgba(128,128,128,0.25) thin solid;"
                      >
                        <v-list-item-content>
                          <v-row>
                            <!--v-col cols="3">
                              <v-list-item-title v-text="item.bis_id"></v-list-item-title>
                            </v-col-->
                            <v-col>
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="!selectedLear"
            v-on:click.stop="onResult"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: "SelectLearDialog",
  props: {
    legrs: {
      type: Array,
      default: () => []
    },
    learMap: {
      type: Object,
      default: () => ({})
    },
    currentMita: {
      type: Object,
      default: () => undefined
    },
    kostMapping: {
      type: Array,
      default: () => []
    },
    migrMapping: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    augrMapping: {
      type: Array,
      default: () => []
    },
    currentAugr: {
      type: String,
      default: () => undefined
    },
    taskLegr: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    selectedLegr: null,
    selectedLear: null,
    show: false,
    search_legr: '',
    search_lear: '',
    headerLegrs: [
      { text: '', value: 'gischl' },
      { text: '', value: 'name' },
    ],
    headerLears: [
      { text: '', value: 'bis_id' },
      { text: '', value: 'name' },
    ],
  }),
  computed: {
    filteredLears() {
      if (!this.selectedLegr) {
        return [];
      }
      let res =  this.learMap[this.selectedLegr] || [];
      if (this.search_lear && this.search_lear.length > 0) {
        const search = this.search_lear.toLowerCase();
        res = res.filter(lear => lear.name.toLowerCase().includes(search) || lear.bis_id.toLowerCase().includes(search));
      }
      return res;
    },
    currentLegrMapping() {
      if (!this.taskLegr) {
        return [];
      }
      // filter augrMapping for current augr
      return [{value: this.taskLegr}];
    },
    currentAugrMapping() {
      if (!this.augrMapping || this.augrMapping.length === 0 || !this.currentAugr) {
        return [];
      }
      // filter augrMapping for current augr
      return this.augrMapping.filter(am => am.key === this.currentAugr);
    },
    currentKostMapping() {
      if (!this.kostMapping || this.kostMapping.length === 0 || !this.currentMita || !this.currentMita.kost) {
        return [];
      }
      // filter kostMapping for current mita kost
      return this.kostMapping.filter(km => km.key === this.currentMita.kost);
    },
    currentMigrMapping() {
      if (!this.migrMapping || this.migrMapping.length === 0 || !this.currentMita || !this.currentMita.migr) {
        return [];
      }
      // filter migrMapping for current mita migr
      return this.migrMapping.filter(mm => mm.key === this.currentMita.migr);
    },
    currentMapping() {
      if (this.currentLegrMapping.length > 0) {
        return this.currentLegrMapping;
      } else if (this.currentAugrMapping.length > 0) {
        return this.currentAugrMapping;
      } else if (this.currentMigrMapping.length > 0) {
        return this.currentMigrMapping;
      } else if (this.currentKostMapping.length > 0) {
        return this.currentKostMapping;
      } else {
        return [];
      }
    },
    myList() {
      // first apply the search filter
      let filtered = [...this.legrs];
      if (this.search_legr && this.search_legr.length > 0) {
        const search = this.search_legr.toLowerCase();
        filtered = filtered.filter(legr => legr.name.toLowerCase().includes(search) || legr.gischl.toLowerCase().includes(search));
      }
      let preselect = {
        title: 'Vorauswahl',
        items: []
      }
      let rest = {
        title: 'Weitere Leistungsgruppen',
        items: []
      }
      let cats = this.categories || [];
      let list = [];
      for (let i = 0; i < filtered.length; i++) {
        let cur = filtered[i];
        let mappingIndex = this.currentMapping.findIndex(lm => lm.value === cur.gischl);
        let catIndex = cats.findIndex(cat => cat.value === cur.gischl);
        if (mappingIndex !== -1) {
          preselect.items.push(cur);
        } else if (catIndex !== -1) {
          let cat = cats[catIndex];
          let catListIndex = list.findIndex(l => l.title === cat.key);
          if (catListIndex === -1) {
            list.push({
              title: cat.key,
              items: [cur]
            });
          } else {
            list[catListIndex].items.push(cur);
          }
        } else {
          rest.items.push(cur);
        }
      }
      // order list by text
      list.sort((a, b) => a.title.localeCompare(b.title));
      // prepend preselect and append rest
      if (preselect.items.length > 0) {
        list.unshift(preselect);
      }
      if (list.length === 0) {
        rest.title = '';
      }
      if (rest.items.length > 0) {
        list.push(rest);
      }
      return list;
    }
  },
  methods: {
    openDialog() {
      this.selectedLegr = null;
      this.selectedLear = null;
      this.show = true;
    },
    getItemClass(item) {
      if (item.id === this.selectedLear || item.name === this.selectedLegr) {
        return 'row-focused';
      }
      return '';
    },
    onResult() {
      this.show = false;
      this.$emit('selected-lear', {
        legr: this.selectedLegr,
        lear: this.selectedLear,
      });
    },
    onSelect(item, type) {
      if (type === 'legr') {
        this.selectedLear = item.name === this.selectedLegr ? this.selectedLear : null;
        this.selectedLegr = item.name;
      } else if (type === 'lear') {
        this.selectedLear = item.id;
      }
    },
  }



}
</script>
<style scoped>
::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

</style>
